import { z } from 'zod'
import { MonitoredArea } from '../../../domain/entities/MonitoredArea'
import { GeometrySchema } from '../../../../@shared/infra/schemas/Geometry.schema'

export const MonitoredAreaSchema = z
	.object({
		id: z.uuid(),
		nome: z.string(),
		geometria: z.preprocess((value: string) => {
			const parsed = JSON.parse(value)
			return GeometrySchema.parse(parsed)
		}, GeometrySchema),
		buffer: z
			.preprocess((value: string) => {
				const parsed = JSON.parse(value)
				return GeometrySchema.parse(parsed)
			}, GeometrySchema)
			.optional(),
	})
	.transform((data) => {
		return new MonitoredArea(data.id, data.nome, data.geometria, data.buffer)
	})
